// extracted by mini-css-extract-plugin
module.exports = {"container":"Investment_container__3qWcF","sep":"Investment_sep__1AZ1g"};